import {useAppSelector} from "../../store/hooks";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";

export const useIsRegistrationWizardSmsLogin = () => {
    const authMode = useAppSelector((state) => state.registrationFlow.authMode);
    const isAuthenticated = useIsAuthenticated();

    return authMode === "login" && !isAuthenticated;
};
import {useAppSelector} from "../../store/hooks";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";

export const useIsRegistrationWizardSmsLogin = () => {
    const authMode = useAppSelector((state) => state.registrationFlow.authMode);
    const isAuthenticated = useIsAuthenticated();

    return authMode === "login" && !isAuthenticated;
};
